import { SEARCH_FILTER_SHOW_ALL_ITEMS_CLICK } from "./actionTypes";

export default () => ({
  type: SEARCH_FILTER_SHOW_ALL_ITEMS_CLICK,
  payload: {
  }
});